import * as yup from 'yup';

export const getContactSchema = yup.object().shape({
  firstName: yup.string().required('Le prénom est requis'),
  lastName: yup.string().required('Le nom est requis'),
  email: yup
    .string()
    .email("Le format de l'adresse email est invalide")
    .required('Une adresse email est requise'),
  subject: yup.string().required('Ce champs est requis'),
  message: yup.string().required('Ce champs est requis'),
});
